import { render, staticRenderFns } from "./MyIncomes.vue?vue&type=template&id=167de9aa"
import script from "./MyIncomes.vue?vue&type=script&lang=js"
export * from "./MyIncomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports